import { DataAmigavel } from '@/shared/utils/datas';
import { Modal } from 'react-bootstrap';
import { ReadGastoProjecaoDto } from './gasto-projecao.types';

function nomeCompleto(nome: string) {
  return nome.trim();
}

interface ModalProjecaoProximaCompraProps {
  show: boolean;
  loading: boolean;
  projecao: ReadGastoProjecaoDto | null;
  onHide: () => void;
}

export function ModalProjecaoProximaCompra({
  show,
  loading,
  projecao,
  onHide,
}: ModalProjecaoProximaCompraProps) {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Projeção da próxima compra</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && <p className="text-muted mb-0">Calculando projeção...</p>}

        {!loading && projecao && (
          <>
            <p className="mb-3">
              <strong>Tipo de gasto:</strong> {projecao.tipoGastoDescricao}
            </p>

            {projecao.mensagem && (
              <p className="alert alert-info py-2 mb-3">{projecao.mensagem}</p>
            )}

            <div className="row g-3 mb-4">
              <div className="col-md-4">
                <div className="border rounded p-3 h-100">
                  <p className="text-muted small mb-1">Compras registradas</p>
                  <p className="fs-5 fw-semibold mb-0">{projecao.totalCompras}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="border rounded p-3 h-100">
                  <p className="text-muted small mb-1">Intervalo médio</p>
                  <p className="fs-5 fw-semibold mb-0">
                    {projecao.intervaloMedioDias != null
                      ? `${projecao.intervaloMedioDias} dia(s)`
                      : '—'}
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="border rounded p-3 h-100">
                  <p className="text-muted small mb-1">Desde a última compra</p>
                  <p className="fs-5 fw-semibold mb-0">
                    {projecao.diasDesdeUltimaCompra != null
                      ? `${projecao.diasDesdeUltimaCompra} dia(s)`
                      : '—'}
                  </p>
                </div>
              </div>
            </div>

            <div className="row g-3 mb-4">
              <div className="col-md-6">
                <div className="border rounded p-3">
                  <p className="text-muted small mb-1">Última compra</p>
                  <p className="fw-semibold mb-0">
                    {projecao.ultimaCompra ? DataAmigavel(projecao.ultimaCompra) : '—'}
                  </p>
                  {projecao.ultimoQuemGastou && (
                    <p className="mt-2 mb-0">
                      <span className="badge bg-secondary me-2">
                        {projecao.ultimoQuemGastou.iniciais}
                      </span>
                      {nomeCompleto(projecao.ultimoQuemGastou.nome)}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="border rounded p-3 border-primary">
                  <p className="text-muted small mb-1">Próxima compra estimada</p>
                  <p className="fw-semibold text-primary fs-5 mb-0">
                    {projecao.proximaCompraEstimada
                      ? DataAmigavel(projecao.proximaCompraEstimada)
                      : '—'}
                  </p>
                  {projecao.proximoQuemGastou && (
                    <p className="mt-2 mb-0">
                      <span className="badge bg-primary me-2">
                        {projecao.proximoQuemGastou.iniciais}
                      </span>
                      <strong>
                        {nomeCompleto(projecao.proximoQuemGastou.nome)}
                      </strong>
                      <span className="text-muted ms-1">(próximo da rodada)</span>
                    </p>
                  )}
                </div>
              </div>
            </div>

            {projecao.participantes.length > 0 && (
              <>
                <h6 className="mb-2">Rodízio (ordem de participação)</h6>
                <div className="d-flex flex-wrap gap-2">
                  {projecao.participantes.map((p) => {
                    const isProximo = projecao.proximoQuemGastou?.id === p.id;
                    const isUltimo = projecao.ultimoQuemGastou?.id === p.id;
                    return (
                      <span
                        key={p.id}
                        className={`badge rounded-pill ${isProximo ? 'bg-primary' : isUltimo ? 'bg-secondary' : 'bg-light text-dark border'}`}
                        title={nomeCompleto(p.nome)}
                      >
                        {p.ordem}. {p.iniciais} — {p.nome.split(' ')[0]}
                      </span>
                    );
                  })}
                </div>
              </>
            )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onHide}>
          Fechar
        </button>
      </Modal.Footer>
    </Modal>
  );
}
